import { DocumentNode, useQuery } from '@apollo/client';

interface Config {
  onCompleted?: (data: any) => void;
  onError?: (error: any) => void;
}

// Custom Apollo hook mirroring the SWR response structure
export const useGQLQuery = (
  gqlQuery: DocumentNode,
  variables = {},
  config: Config = {}
) => {
  const { onCompleted, onError, ...queryOptions } = config;
  const { data, error, loading, refetch } = useQuery(gqlQuery, {
    ...variables,
    onCompleted: data => {
      if (onCompleted) onCompleted(data); // Call the provided onCompleted callback, if any
    },
    onError: error => {
      if (onError) onError(error); // Call the provided onError callback, if any
    },
    ...queryOptions, // Spread any remaining Apollo query options });
  });
  // Return data and error in SWR format
  return { data, error, loading, refetch };
};
